<!-- 首页 -->
<template>
  <div class="home">
    <!-- 导航栏 -->
    <van-nav-bar title="求职管理" fixed placeholder z-index="10"></van-nav-bar>
    <!-- 首页推荐 -->
    <Job />
  </div>
</template>
<script>
import Mine from "./mine";
import Job from "./jobSearch";
import Recommend from "../recommend/recommend";
import Tabbar from "@/components/tabBar/tabBoss";
import { Dialog } from "vant";
import { mapState } from "vuex";
export default {
  components: { Mine, Job, Recommend, Tabbar },
  inject: ["Token"],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.Token();
    // Dialog.confirm({
    //   title: "提示",
    //   message: "还没有登录！是否现在前往登录"
    // })
    //   .then(() => {
    //     this.$router.replace({
    //       name: "Register"
    //     });
    //   })
    //   .catch(() => {
    //     // on cancel
    //   });
  }
};
</script>
<style lang='less' scoped>
/deep/[class*="van-hairline"]::after {
  border: 0;
}
</style>